// ======================================================
// STRUCTURE GLOBALE DES PERMISSIONS ET DROITS GRANULAIRES
// ======================================================
export const PERMISSION_STRUCTURE = [
  {
    id: 'dashboard', 
    label: 'Tableau de Bord & Statistiques',
    subs: [
      { id: 'dashboard_view_products', label: 'Voir Total Produits', parent_link_id: 'dashboard' },
      { id: 'dashboard_view_alerts', label: 'Voir Alertes Stock', parent_link_id: 'dashboard' },
      { id: 'dashboard_view_sales_day', label: 'Voir Ventes Journalières', parent_link_id: 'dashboard' },
      { id: 'dashboard_view_credit', label: 'Voir Total Créances Clients', parent_link_id: 'dashboard' }
    ]
  },
  {
    id: 'params', 
    label: 'Paramètres & Système',
    subs: [
      { id: 'params_edit_settings', label: 'Page : Modifier les paramètres société', parent_link_id: 'params' },
      { id: 'params_view_licence', label: 'Page : Voir les détails de la licence', parent_link_id: 'params' },
      { id: 'params_view_audit', label: 'Page : Accès au Journal Audit (Traçabilité)', parent_link_id: 'params' },
      { id: 'params_cloud_push', label: 'Page : Sauvegarder les données vers le Cloud', parent_link_id: 'params' },
      { id: 'params_cloud_restore', label: 'Page : Restaurer les données depuis le Cloud', parent_link_id: 'params' },
      { id: 'params_btn_update_institution', label: 'Mettre à jour paramètre institution', parent_link_id: 'params' }
    ]
  },
  {
    id: 'rapports_manager', 
    label: 'Rapports Manager',
    subs: [
      { id: 'rapports_ca', label: 'Rapport CA', parent_link_id: 'rapports_manager' },
      { id: 'rapports_encaissement', label: 'Rapport Encaissement', parent_link_id: 'rapports_manager' },
      { id: 'rapports_night_audit', label: 'Rapport Night Audit', parent_link_id: 'rapports_manager' }
    ]
  },
  {
    id: 'tiers', 
    label: 'Gestion tiers',
    subs: [
      { id: 'tiers_fournisseur', label: 'Enregistrer & Gérer les Fournisseurs', parent_link_id: 'tiers' },
      { id: 'tiers_client', label: 'Enregistrer & Gérer un Client', parent_link_id: 'tiers' }
    ]
  },
  {
    id: 'HEBERGEMENT', 
    label: 'Module : Hébergement & Hôtellerie',
    subs: [
      { id: 'heb_planning', label: 'Page : Planning & Séjours / Détails', parent_link_id: 'HEBERGEMENT' },
      { id: 'heb_nouvelle_res', label: 'Page : Nouvelle Réservation', parent_link_id: 'HEBERGEMENT' },
      { id: 'heb_historique_res', label: 'Page : Historique des Réservations', parent_link_id: 'HEBERGEMENT' },
      { id: 'heb_checkin_checkout', label: 'Page : Check-in & Check-out Walkin', parent_link_id: 'HEBERGEMENT' },
      { id: 'heb_composition_cat', label: 'Page : Checkout & Facturation Séjour', parent_link_id: 'HEBERGEMENT' },
      { id: 'heb_encaissements', label: 'Page : Encaissements & Règlements Hôtel', parent_link_id: 'HEBERGEMENT' },
      { id: 'heb_extras_config', label: 'Page : Configuration des Extras', parent_link_id: 'HEBERGEMENT' },
      { id: 'heb_extras_guichet', label: 'Page : Guichet Vente Extras', parent_link_id: 'HEBERGEMENT' },
      { id: 'heb_extras_historique', label: 'Page : Historique Extras', parent_link_id: 'HEBERGEMENT' },
      { id: 'heb_categories', label: 'Page : Catégories de Chambres', parent_link_id: 'HEBERGEMENT' },
      { id: 'heb_composants', label: 'Page : Prestations & Composants', parent_link_id: 'HEBERGEMENT' },
      { id: 'heb_chambres', label: 'Page : Chambres Physiques & Paramétrage', parent_link_id: 'HEBERGEMENT' },
      { id: 'heb_regles_tarifs', label: 'Page : Règles de Tarifs Horaires', parent_link_id: 'HEBERGEMENT' },
      { id: 'heb_parametres_horaires', label: 'Page : Paramètres Horaires & No-Show', parent_link_id: 'HEBERGEMENT' },
      { id: 'heb_civilites', label: 'Page : Gestion des Civilités', parent_link_id: 'HEBERGEMENT' },
      { id: 'heb_societes', label: 'Page : Gestion des Sociétés', parent_link_id: 'HEBERGEMENT' },
      { id: 'dashboard_view_total_chambres', label: '👉 Dashboard : Voir Total Chambres', parent_link_id: 'HEBERGEMENT' },
      { id: 'dashboard_view_chambres_dispo', label: '👉 Dashboard : Voir Chambres Disponibles', parent_link_id: 'HEBERGEMENT' },
      { id: 'dashboard_view_chambres_occupees', label: '👉 Dashboard : Voir Chambres Occupées', parent_link_id: 'HEBERGEMENT' },
      { id: 'dashboard_view_arrivees_prevues', label: '👉 Dashboard : Voir Arrivées Prévues (Aujourd\'hui)', parent_link_id: 'HEBERGEMENT' },
      { id: 'dashboard_view_departs_attendus', label: '👉 Dashboard : Voir Départs Attendus (Aujourd\'hui)', parent_link_id: 'HEBERGEMENT' }
    ]
  },
{
    id: 'access_pos', 
    label: 'Terminal de Vente (POS)',
    subs: [
      { id: 'pos_vente_create', label: 'Accès au POS (Vente au Comptoir)', parent_link_id: 'access_pos' },
      { id: 'pos_add', label: 'Vente Au Panier (Provisoire)', parent_link_id: 'access_pos' },
      { id: 'pos_validate', label: 'Valider un Panier', parent_link_id: 'access_pos' },
      { id: 'pos_invoice', label: 'Vente Normalisée', parent_link_id: 'access_pos' },
      { id: 'pos_restaurant_create', label: 'POS Restaurant & Menus (Avec Production)', parent_link_id: 'access_pos' },
      { id: 'pos_restaurant_vsp_create', label: 'POS Restaurant & Menus (Sans Production - VSP)', parent_link_id: 'access_pos' }, // 👈 ID unique mis à jour
      { id: 'pos_history', label: 'Historique des Ventes', parent_link_id: 'access_pos' },
      { id: 'pos_vente_grille', label: 'Page : Grille Vente Commerciale (Constitution Matin)', parent_link_id: 'access_pos' },
      { id: 'pos_vente_liste', label: 'Page : Liste des Tournées Commerciales (Clôture Soir)', parent_link_id: 'access_pos' },
      { id: 'pos_details', label: 'Rapport des ventes détaillées par date', parent_link_id: 'access_pos' },
      { id: 'pos_view_marge', label: '👉 Affichage de la Marge Brute et des Bénéfices', parent_link_id: 'access_pos' },
      { id: 'pos_cancel_sale', label: '👉 Bouton : Annuler une facture ou un lot de vente', parent_link_id: 'access_pos' },
      { id: 'pos_return_item', label: '👉 Bouton : Effectuer un retour article au POS', parent_link_id: 'access_pos' },
      { id: 'pos_creances_clients', label: 'Suivi des Créances Clients', parent_link_id: 'access_pos' } 
    ]
  }, 
  {
    id: 'gestion_caisse', 
    label: 'Gestion de Caisse', 
    subs: [
      { id: 'caisse_close', label: 'Page : Clôture de la Caisse / Vente', parent_link_id: 'gestion_caisse' },
      { id: 'caisse_history_cloture', label: 'Page : Historique des Clôtures de Caisse', parent_link_id: 'gestion_caisse' },
      { id: 'caisse_methodes', label: 'Page : Ajouter / Gérer un Moyen de Paiement', parent_link_id: 'gestion_caisse' }
    ]
  },
  {
    id: 'logistique', 
    label: 'Stocks & Achats (Logistique)',
    subs: [
      { id: 'log_suppliers_dettes', label: 'Suivi des Dettes Fournisseurs', parent_link_id: 'logistique' },
      { id: 'log_buy', label: 'Effectuer un Achat / Entrée de Stock', parent_link_id: 'logistique' },
      { id: 'log_returns', label: 'Gérer les Retours / Avoirs Fournisseurs', parent_link_id: 'logistique' },
      { id: 'log_history', label: 'Consulter l\'Historique des Achats', parent_link_id: 'logistique' },
      { id: 'log_inventory', label: 'Accès au Hub & Saisie d\'Inventaire', parent_link_id: 'logistique' },
      { id: 'log_inventory_hist', label: 'Consulter l’Historique des Inventaires', parent_link_id: 'logistique' },
      { id: 'log_bon_commande', label: 'Créer un Bon de Commande Fournisseur', parent_link_id: 'logistique' },
      { id: 'log_historique_bon', label: 'Consulter l\'Historique des Bons de Commande', parent_link_id: 'logistique' },
      { id: 'log_ajustement', label: 'Régularisation du Stock (Pertes / Avaries)', parent_link_id: 'logistique' },
      { id: 'log_historique_ajustement', label: 'Consulter l’Historique des Régularisations', parent_link_id: 'logistique' }
    ]
  },
  {
    id: 'access_emballages',
    label: 'Gestionnaire des Emballages',
    subs: [
      { id: 'emb_create', label: 'Page : Création Emballage', parent_link_id: 'access_emballages' },
      { id: 'emb_achat', label: 'Page : Achat Emballages', parent_link_id: 'access_emballages' },
      { id: 'emb_regles', label: 'Page : Configuration des Flux & Consignation', parent_link_id: 'access_emballages' },
      { id: 'emb_consignation', label: 'Page : Consignation Emballages', parent_link_id: 'access_emballages' },
      { id: 'emb_history', label: 'Page : Historique des Flux Emballages', parent_link_id: 'access_emballages' },
      { id: 'emb_inventory_suivi', label: 'Page : Suivi & Lancement Inv. Emballage', parent_link_id: 'access_emballages' },
      { id: 'emb_inventory_saisie', label: 'Page : Saisie Inventaire Emballage', parent_link_id: 'access_emballages' },
      { id: 'emb_btn_modify', label: '👉 Bouton : Modifier un achat d\'emballage', parent_link_id: 'access_emballages' },
      { id: 'emb_btn_archive', label: '👉 Bouton : Archiver un achat d\'emballage', parent_link_id: 'access_emballages' },
      { id: 'emb_btn_delete', label: '👉 Bouton : Supprimer définitivement un achat', parent_link_id: 'access_emballages' },
      { id: 'emb_rule_btn_create', label: '👉 Bouton Règle : Créer / Ajouter une nouvelle règle', parent_link_id: 'access_emballages' },
      { id: 'emb_rule_btn_modify', label: '👉 Bouton Règle : Modifier une règle de consignation', parent_link_id: 'access_emballages' },
      { id: 'emb_rule_btn_delete', label: '👉 Bouton Règle : Supprimer une règle de consignation', parent_link_id: 'access_emballages' },
      { id: 'emb_cons_btn_modify', label: '👉 Bouton Consignation : Modifier / Ajuster un flux', parent_link_id: 'access_emballages' },
      { id: 'emb_cons_btn_delete', label: '👉 Bouton Consignation : Supprimer / Annuler un flux', parent_link_id: 'access_emballages' }
    ]
  },
  {
    id: 'access_articles', 
    label: 'Gestionnaire Articles',
    subs: [
      { id: 'art_list', label: 'Liste des Produits / Catalogue', parent_link_id: 'access_articles' },
      { id: 'art_view_financials', label: '👉 Affichage des Valeurs d\'Achat, Vente et CMP', parent_link_id: 'access_articles' },
      { id: 'art_create', label: 'Création d\'un Article', parent_link_id: 'access_articles' },
      { id: 'art_mod', label: 'Modification d\'un Article', parent_link_id: 'access_articles' },
      { id: 'art_edit', label: 'Modification d\'un Article', parent_link_id: 'access_articles' },
      { id: 'art_view', label: 'Page : Ajouter Conditionnement (Unités)', parent_link_id: 'access_articles' },
      { id: 'art_categories', label: 'Familles Catégories & Groupes', parent_link_id: 'access_articles' },
      { id: 'art_tables', label: 'Gestion des Tables (Restauration/Bar)', parent_link_id: 'access_articles' },
      { id: 'art_gl', label: 'Grand livre Article (Historique global)', parent_link_id: 'access_articles' },
      { id: 'art_btn_create_submit', label: '👉 Bouton : Enregistrer la création d\'un article', parent_link_id: 'access_articles' },
      { id: 'art_btn_edit_submit', label: '👉 Bouton : Enregistrer la modification d\'un article', parent_link_id: 'access_articles' }
    ]
  },
  {
    id: 'menu_users_access', 
    label: 'Gestion Utilisateurs & Personnel',
    subs: [
      { id: 'user_create', label: 'Page : Comptes Utilisateurs & Accès', parent_link_id: 'menu_users_access' },
      { id: 'staff_manage', label: 'Page : Gestion du Staff (Personnel)', parent_link_id: 'menu_users_access' },
      { id: 'user_btn_create_submit', label: '👉 Bouton : Enregistrer un NOUVEAU collaborateur', parent_link_id: 'menu_users_access' },
      { id: 'user_btn_edit_submit', label: '👉 Bouton : Modifier ou suspendre un compte utilisateur', parent_link_id: 'menu_users_access' },
      { id: 'staff_btn_create', label: '👉 Bouton : Enregistrer / Créer une nouvelle fiche employé', parent_link_id: 'menu_users_access' },
      { id: 'staff_btn_modify', label: '👉 Bouton : Modifier / Éditer les coordonnées d\'un employé', parent_link_id: 'menu_users_access' },
      { id: 'staff_btn_archive', label: '👉 Bouton : Archiver / Réactiver un contrat employé', parent_link_id: 'menu_users_access' }
    ]
  },
  {
    id: 'compta', 
    label: 'Gestion Comptable',
    subs: [
      { id: 'compta_ex', label: 'Exercices Comptables & RAN', parent_link_id: 'compta' },
      { id: 'compta_jr', label: 'Codes Journaux & Types de Brouillards', parent_link_id: 'compta' },
      { id: 'compta_plan', label: 'Plan Comptable Général', parent_link_id: 'compta' },
      { id: 'compta_tiers', label: 'Plan des Tiers', parent_link_id: 'compta' },
      { id: 'analytique_plan', label: 'Plan Analytique & Configuration Répartitions', parent_link_id: 'compta' },
      { id: 'compta_brouillon', label: 'Saisie Assistant / Journal Brouillon', parent_link_id: 'compta' },
      { id: 'compta_val', label: 'Validation des Brouillons & Dépenses Trésorerie', parent_link_id: 'compta' },
      { id: 'compta_gen', label: 'Saisie Journalière & Ventilation du Brouillard', parent_link_id: 'compta' },
      { id: 'compta_treso_ventilation', label: 'Ventilation du Brouillard de Trésorerie', parent_link_id: 'compta' },
      { id: 'compta_treso_saisie_hub', label: 'Hub de Saisie Trésorerie (Caissier)', parent_link_id: 'compta' },
      { id: 'compta_treso_val', label: 'Valider une Dépense / Trésorerie', parent_link_id: 'compta' },
      { id: 'compta_cloture', label: 'Clôture & Centralisation Journalière', parent_link_id: 'compta' },
      { id: 'compta_ecritures_auto', label: 'Paramètres Écritures Automatiques', parent_link_id: 'compta' },
      { id: 'compta_brouillard_config', label: 'Configuration du Brouillard', parent_link_id: 'compta' },
      { id: 'compta_treso_cash', label: 'Gestion Trésorerie Caisse/Banques', parent_link_id: 'compta' },
      { id: 'rpt_bal_comptes', label: 'Rapport : Balance des comptes', parent_link_id: 'compta' },
      { id: 'rpt_bal_tiers', label: 'Rapport : Balance des tiers', parent_link_id: 'compta' },
      { id: 'compta_rpt_bal_agee', label: 'Rapport : Balance âgée', parent_link_id: 'compta' },
      { id: 'compta_rpt_bal_ana', label: 'Rapport : Balance analytique', parent_link_id: 'compta' },
      { id: 'compta_rpt_gl_comptes', label: 'Rapport : Grand livre des comptes', parent_link_id: 'compta' },
      { id: 'compta_rpt_gl_tiers', label: 'Rapport : Grand livre des tiers', parent_link_id: 'compta' },
      { id: 'compta_rpt_gl_ana', label: 'Rapport : Grand livre analytique', parent_link_id: 'compta' },
      { id: 'compta_rpt_central', label: 'Rapport : Journal Centralisateur', parent_link_id: 'compta' },
      { id: 'compta_rpt_bilan', label: 'Rapport : Bilan', parent_link_id: 'compta' },
      { id: 'rpt_resultat', label: 'Rapport : Compte de résultat', parent_link_id: 'compta' },
      { id: 'rpt_tft', label: 'Rapport : TFT (Flux Trésorerie)', parent_link_id: 'compta' },
      { id: 'compta_etats_recap', label: 'États Financiers Recap', parent_link_id: 'compta' }
    ]
  },
  {
    id: 'SCOOL', 
    label: 'Module : Gestion Scolaire',
    subs: [
      { id: 'scol_cycles_manage', label: 'Page : Cycles Pédagogiques', parent_link_id: 'SCOOL' },
      { id: 'scol_annees_manage', label: 'Page : Années Scolaires', parent_link_id: 'SCOOL' },
      { id: 'scol_niveaux_manage', label: 'Page : Niveaux et Classes', parent_link_id: 'SCOOL' },
      { id: 'scol_matieres_manage', label: 'Page : Matières et Affectations', parent_link_id: 'SCOOL' },
      { id: 'scol_eleves_manage', label: 'Page : Élèves et Tuteurs', parent_link_id: 'SCOOL' },
      { id: 'scol_enseignants_manage', label: 'Page : Enseignants', parent_link_id: 'SCOOL' }
    ]
  },
  {
    id: 'access_analytique', 
    label: 'Gestion Analytique & Production',
    subs: [
      { id: 'analytique_mp_categories', label: 'Catégories Matières Premières', parent_link_id: 'access_analytique' },
      { id: 'analytique_mp', label: 'Gérer les Matières Premières & Achats MP', parent_link_id: 'access_analytique' },
      { id: 'analytique_mp_inventaire', label: 'Inventaire Matières Premières (MP)', parent_link_id: 'access_analytique' },
      { id: 'analytique_psf_hist', label: 'Liste des PSF, Historique & Traçabilité', parent_link_id: 'access_analytique' },
      { id: 'analytique_psf_inventaire', label: 'Inventaire Produits Semi-finis (PSF)', parent_link_id: 'access_analytique' },
      { id: 'analytique_ft', label: 'Gérer les Fiches Techniques & Paramétrage', parent_link_id: 'access_analytique' },
      { id: 'prod_sur_mesure', label: 'Vente Sur-Mesure', parent_link_id: 'access_analytique' },
      { id: 'prod_besoin', label: 'Émettre un Besoin (Cuisine/Prod)', parent_link_id: 'access_analytique' },
      { id: 'prod_enregistrer_commande', label: 'Enregistrement de Commande de Production', parent_link_id: 'access_analytique' },
      { id: 'prod_magasin_verif', label: 'Vérification de Stock (Magasin)', parent_link_id: 'access_analytique' },
      { id: 'prod_magasin_reception', label: 'Magasinage & Réception Production', parent_link_id: 'access_analytique' },
      { id: 'prod_pilotage', label: 'Pilotage & Lancements de Production', parent_link_id: 'access_analytique' },
      { id: 'prod_regularisations', label: 'Régul. Stocks en Attente (MP/PSF)', parent_link_id: 'access_analytique' },
      { id: 'analytique_prod_hist', label: 'Rapports & Historique de Production', parent_link_id: 'access_analytique' },
      { id: 'prod_conso_dep', label: 'Consommation Directe par Département', parent_link_id: 'access_analytique' },
      { id: 'prod_conso_dep_hist', label: 'Historique Conso. Départements', parent_link_id: 'access_analytique' },
      { id: 'prod_magasin_hist_conso', label: 'Historique des Consommations MP', parent_link_id: 'access_analytique' }
    ]
  }
];

// ======================================================
// LOGIQUE DE RÉCUPÉRATION ET D'HÉRITAGE DES PERMISSIONS
// ======================================================
export const getUserPermissions = () => {
  const userData = localStorage.getItem('user');
  if (!userData) return {};
  
  try {
    const user = JSON.parse(userData);
    const role = (user.role || '').toLowerCase().trim();
    
    // 1. SI ADMIN OU SUPER_ADMIN -> FULL ACCÈS AUTOMATIQUE
    if (role === 'admin' || role === 'super_admin') {
      const adminPerms = {};
      PERMISSION_STRUCTURE.forEach(group => {
        adminPerms[group.id] = true;
        if (group.subs) {
          group.subs.forEach(sub => {
            adminPerms[sub.id] = true;
          });
        }
      });
      return adminPerms;
    }

    // 2. DÉCODAGE ROBUSTE DES PERMISSIONS COLLABORATEUR
    let perms = user.permissions;

    // Décodage récursif si c'est une string JSON (parfois doublement stringifiée)
    while (typeof perms === 'string' && perms.trim() !== "") {
      try {
        perms = JSON.parse(perms);
      } catch (e) {
        break; 
      }
    }

    // Sécurité supplémentaire : Si les permissions ont été stockées sous forme de Tableau (ex: ['pos_vente_create', ...])
    if (Array.isArray(perms)) {
      const formattedPerms = {};
      perms.forEach(p => {
        if (typeof p === 'string') {
          formattedPerms[p] = true;
        }
      });
      perms = formattedPerms;
    }

    if (!perms || typeof perms !== 'object') {
      return {};
    }

    const computedPerms = { ...perms };
    
    // 🎯 RECONSOLIDATION MAÎTRESSE : Si un sous-bouton ou sous-droit est coché, la page parente s'ouvre d'office
    PERMISSION_STRUCTURE.forEach(group => {
      // Si le groupe principal est explicitement activé
      const groupVal = perms[group.id];
      if (groupVal === true || groupVal === 1 || groupVal === 'true' || groupVal === '1') {
        computedPerms[group.id] = true;
      }

      if (group.subs) {
        const hasActiveChild = group.subs.some(sub => {
          const val = perms[sub.id];
          return val === true || val === 1 || val === 'true' || val === '1';
        });
        
        if (hasActiveChild) {
          computedPerms[group.id] = true; 
        }
      }
    });

    return computedPerms;
      
  } catch (e) {
    console.error("Erreur critique lecture permissions:", e);
    return {};
  }
};

export const hasPermission = (permissionId) => {
  const perms = getUserPermissions();
  const val = perms[permissionId];
  return val === true || val === 1 || val === 'true' || val === '1';
};

export const getFilteredStructureForManager = () => {
  return PERMISSION_STRUCTURE;
};